import { useText } from "@sveabank/cc-common";
import type { OnboardingPackageId } from "../../types/package";

const usePackageTitle = (id: OnboardingPackageId) => {
	const [t, texts] = useText();
	const preTitle = t(texts.choosePackage[id].targetGroup);
	const titleText = t(texts.choosePackage[id].title);

	return `${preTitle} ${titleText}`;
};

export default usePackageTitle;
